export const RATES = { AED: 1, USD: 3.67, EUR: 4.0, BDT: 0.0307 };
export const SYMBOLS = { AED: "AED", USD: "USD", EUR: "EUR", BDT: "BDT" };
export const FLAGS = { AED: "🇦🇪", USD: "🇺🇸", EUR: "🇪🇺", BDT: "🇧🇩" };

export function convertPrice(priceAED, currency) {
  const val = parseFloat(String(priceAED).replace(/,/g, ""));
  if (isNaN(val)) return null;
  const rate = RATES[currency];
  const c = val / rate;
  let rounded;
  if (currency === "AED") rounded = val;
  else if (c < 100) rounded = Math.round(c / 5) * 5;
  else if (c < 1000) rounded = Math.round(c / 10) * 10;
  else rounded = Math.round(c / 50) * 50;
  return rounded.toLocaleString();
}

export const ALL_PACKAGES = [
  // Web & App Development
  { service: "Web & App Development", name: "Single Page Landing", price: "750" },
  { service: "Web & App Development", name: "Corporate Website", price: "3,500" },
  { service: "Web & App Development", name: "Blog / Content Platform", price: "3,000" },
  { service: "Web & App Development", name: "Creative Portfolio", price: "2,800" },
  { service: "Web & App Development", name: "Restaurant Order App", price: "4,500" },
  { service: "Web & App Development", name: "WooCommerce Shop", price: "5,000" },
  { service: "Web & App Development", name: "Shopify Custom Store", price: "6,500" },
  { service: "Web & App Development", name: "Custom React Shop", price: "12,000" },
  { service: "Web & App Development", name: "Appointment & Booking", price: "6,000" },
  { service: "Web & App Development", name: "Event Ticketing App", price: "7,000" },
  { service: "Web & App Development", name: "Real Estate Portal", price: "8,000" },
  { service: "Web & App Development", name: "Job & Recruitment Portal", price: "9,000" },
  { service: "Web & App Development", name: "Classified Ads Portal", price: "7,500" },
  { service: "Web & App Development", name: "Healthcare Appointment", price: "6,500" },
  { service: "Web & App Development", name: "Automotive / Car Rental", price: "8,000" },
  { service: "Web & App Development", name: "SaaS Platform MVP", price: "15,000" },
  { service: "Web & App Development", name: "Enterprise ERP/CRM", price: "25,000" },
  { service: "Web & App Development", name: "e-Learning LMS", price: "8,500" },
  { service: "Web & App Development", name: "Helpdesk Support", price: "8,000" },
  { service: "Web & App Development", name: "API Backend Stack", price: "5,500" },
  // UI/UX Design
  { service: "UI/UX Design", name: "UX Usability Audit", price: "1,200" },
  { service: "UI/UX Design", name: "User Research & Personas", price: "1,500" },
  { service: "UI/UX Design", name: "Information Architecture", price: "1,800" },
  { service: "UI/UX Design", name: "Lo-Fi Wireframing", price: "2,500" },
  { service: "UI/UX Design", name: "Usability Testing", price: "2,200" },
  { service: "UI/UX Design", name: "Landing Page UI", price: "1,500" },
  { service: "UI/UX Design", name: "Corporate Web UI", price: "3,500" },
  { service: "UI/UX Design", name: "Mobile App UI", price: "5,000" },
  { service: "UI/UX Design", name: "E-Commerce UI", price: "4,500" },
  { service: "UI/UX Design", name: "Dashboard UI", price: "6,000" },
  { service: "UI/UX Design", name: "Brand Identity Guide", price: "2,000" },
  { service: "UI/UX Design", name: "Figma Design System", price: "3,800" },
  { service: "UI/UX Design", name: "Icons & Graphics Kit", price: "1,800" },
  { service: "UI/UX Design", name: "Developer Hand-Off", price: "1,500" },
  { service: "UI/UX Design", name: "Pitch Deck UI Layout", price: "1,500" },
  { service: "UI/UX Design", name: "Hi-Fi Prototype", price: "3,000" },
  { service: "UI/UX Design", name: "Micro-Interactions", price: "2,500" },
  { service: "UI/UX Design", name: "Redesign Concept", price: "4,000" },
  { service: "UI/UX Design", name: "MVP App UI/UX", price: "3,500" },
  { service: "UI/UX Design", name: "SaaS Platform Workspace", price: "7,500" },
  // Cloud & DevOps
  { service: "Cloud & DevOps", name: "DevOps Setup", price: "3,500" },
  { service: "Cloud & DevOps", name: "CI/CD Automation", price: "6,800" },
  { service: "Cloud & DevOps", name: "Enterprise Cloud", price: "12,000" },
  // VPS & Hosting (monthly)
  { service: "VPS & Hosting", name: "Managed VPS Starter — /mo", price: "250" },
  { service: "VPS & Hosting", name: "Business Dedicated — /mo", price: "750" },
  { service: "VPS & Hosting", name: "Enterprise Cluster — /mo", price: "1,800" },
  // AWS & Cloud Platforms
  { service: "AWS & Cloud Platforms", name: "AWS Basic Setup", price: "3,000" },
  { service: "AWS & Cloud Platforms", name: "AWS RDS & Serverless", price: "6,500" },
  { service: "AWS & Cloud Platforms", name: "AWS High Availability", price: "12,500" },
  // Server Management (monthly)
  { service: "Server Management", name: "Single Server Admin — /mo", price: "450" },
  { service: "Server Management", name: "Standard Multi-Server — /mo", price: "1,200" },
  { service: "Server Management", name: "High-Performance — /mo", price: "2,500" },
  // AI & Data
  { service: "AI & Data", name: "Business Dashboards", price: "4,500" },
  { service: "AI & Data", name: "Custom AI Chatbot", price: "9,000" },
  { service: "AI & Data", name: "Predictive ML & RPA", price: "18,000" },
  // Cybersecurity
  { service: "Cybersecurity", name: "Security Audit", price: "2,000" },
  { service: "Cybersecurity", name: "Penetration Testing", price: "5,500" },
  { service: "Cybersecurity", name: "Enterprise Compliance", price: "10,000" },
  // Migration & Maintenance
  { service: "Migration & Maintenance", name: "Basic Site Migration", price: "1,500" },
  { service: "Migration & Maintenance", name: "Server & DB Migration", price: "4,000" },
  { service: "Migration & Maintenance", name: "Annual Maintenance", price: "6,000" },
];

export const SERVICES_ORDER = [
  "Web & App Development",
  "UI/UX Design",
  "Cloud & DevOps",
  "VPS & Hosting",
  "AWS & Cloud Platforms",
  "Server Management",
  "AI & Data",
  "Cybersecurity",
  "Migration & Maintenance",
];
